import { ExternalLink } from 'lucide-react';
import { useState } from 'react';

interface AdCreative {
  id: string;
  title: string;
  description: string;
  sponsor: string;
  ctaLabel: string;
  href?: string;
  imageUrl?: string;
  badge?: string;
  background?: string;
}

interface BannerAdProps {
  creative: AdCreative;
}

export default function BannerAd({ creative }: BannerAdProps) {
  const [imageFailed, setImageFailed] = useState(false);
  const hasValidHref = creative.href && creative.href !== '#' && creative.href !== '';

  const content = (
    <div className="flex min-h-[90px] items-center gap-4 overflow-hidden rounded-[22px] border border-slate-200/80 px-4 py-4 shadow-sm">
      <div className="min-w-0 flex-1">
        <div className="mb-2 flex items-center gap-2">
          <span className="rounded-full bg-slate-900/85 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.22em] text-white">
            {creative.badge || '广告'}
          </span>
          <span className="text-xs font-medium text-slate-500">{creative.sponsor}</span>
        </div>
        <p className="text-sm font-semibold text-slate-900">{creative.title}</p>
        <p className="mt-1 line-clamp-2 text-xs leading-5 text-slate-600">{creative.description}</p>
      </div>
      {creative.imageUrl && !imageFailed ? (
        <img src={creative.imageUrl} alt={creative.title} className="h-14 w-14 rounded-2xl object-cover shadow-sm" onError={() => setImageFailed(true)} />
      ) : (
        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-white/85 text-[11px] font-semibold text-slate-700 shadow-sm">AD</div>
      )}
      <div className="hidden shrink-0 items-center gap-1 text-xs font-semibold text-slate-700 sm:flex">
        <span>{creative.ctaLabel}</span>
        <ExternalLink className="h-3.5 w-3.5" />
      </div>
    </div>
  );

  return (
    <div className="mt-4">
      {hasValidHref ? (
        <a href={creative.href} className="group block transition hover:-translate-y-0.5 hover:shadow-md" style={{ background: creative.background || 'linear-gradient(120deg, #fff, #dbeafe)' }}>
          {content}
        </a>
      ) : (
        <div style={{ background: creative.background || 'linear-gradient(120deg, #fff, #dbeafe)' }}>{content}</div>
      )}
    </div>
  );
}
